import type { TradeParams } from '@/client/store/trade-store';
import { LoginApiResult } from '@/libs/sdk/api';
import { createContext, MouseEvent, useContext } from 'react';

export type LoginPhase =
  | 'idle'
  | 'connecting'
  | 'switching-chain'
  | 'loading-client'
  | 'signing'
  | 'verifying'
  | 'authenticated'
  | 'error';
export type LoginResult = { attemptId: number; outcome: 'success' | 'cancelled' | 'error' };
export type LoginOptions = { source?: 'trade'; tradeParams?: TradeParams };

export interface AuthInterface {
  loginPhase: LoginPhase;
  lastLoginResult?: LoginResult;
  isAuthed: boolean;
  isAuthLoading: boolean;
  data?: LoginApiResult;
  login: (options?: LoginOptions | MouseEvent) => void;
  logout: (options?: { silent?: boolean }) => Promise<void>;
}

// Default context values
export const AuthContext = createContext<AuthInterface>({
  loginPhase: 'idle',
  isAuthLoading: false,
  isAuthed: false,
  data: undefined,
  login: () => {
    console.log('Auth disabled - login mock');
  },
  logout: async () => {
    console.log('Auth disabled - logout mock');
  },
});

export const useAuth = () => {
  return useContext(AuthContext);
};
